<template>
  <div class="orderDetailsPage">
    <headerNotice routerName="佣金流水"></headerNotice>
    <!-- 搜索条 -->
    <div class="searchBox">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline searchForm">
        <el-form-item label="客户名称">
          <el-input v-model="searchForm.username" clearable placeholder="客户名称"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderCode" clearable placeholder="订单号" style="width: 180px"></el-input>
        </el-form-item>

        <el-form-item style="margin-right:40px;" label="时间范围">
          <el-date-picker
            v-model="submitTime"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <!-- <el-form-item style="margin-left:40px;" label="快速查看">
          <el-button type="primary" @click="onSearch">最近七天</el-button>
          <el-button type="primary" @click="onSearch">最近一个月</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <!-- 搜索结果列表 -->
    <div class="searchList">
      <div class="searchListContent">
        <el-table
          ref="searchListTableData"
          :data="searchListTableData"
          style="width: 100%"
          show-summary
          border
          :v-loading="loading"
        >
          <el-table-column align="center" width="180" prop="orderCode" label="订单号"></el-table-column>
          <el-table-column align="center" width="180" prop="username" label="客户名称"></el-table-column>
          <el-table-column align="center" prop="commissionTime" label="分佣时间"></el-table-column>
          <el-table-column align="center" prop="commissionSource" label="分销关系"></el-table-column>
          <el-table-column align="center" prop="subordinateName" label="所属客户名称"></el-table-column>
          <el-table-column align="center" prop="commission" label="佣金"></el-table-column>
        </el-table>
      </div>
      <!--搜索列表分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[25, 50, 75, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      userId: "",
      SubordinateId: "",
      loading: true,
      SkipCount: 0,
      totalCount: 0, //总数据条数

      maxResultCount: 25, //默认一页显示的个数,
      currentPage: 1,
      baseUrl: this.$store.state.apiUrl,
      dateData: [], //日期
      orderDetailSearchForm: {
        //搜索表单
        userName: "",
        StartTime: "",
        EndTime: ""
      },
      searchForm: {
        //搜索表单
        username: "",
        orderCode: "",
        SkipCount: 0,
        startTime: "",
        endTime: ""
      },
      submitTime: [], //时间
      searchListTableData: 
      [
       
      ], //表单数据
      currentPage_coupon: 1,
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  components: {
    headerNotice
  },
  created() {},
  mounted() {
    this.getDatas({MaxResultCount:this.maxResultCount});
  },
  methods: {
    //搜索
    onSearch() {
      // let self = this;
      // let form = this.searchForm;
      // form.SkipCount = 0
      // this.getDatas(form)
      // this.currentPage = 1
      let params = this.searchForm;
      if (this.submitTime.length) {
        let startTime = this.submitTime[0];
        let endTime = this.submitTime[1];
        params.startTime = startTime;
        params.endTime = endTime;
      }
      params.MaxResultCount = this.maxResultCount;
      this.getDatas(params);
      this.currentPage = 1;
    },
    dateDataChange(val) {
      if (!val) {
        this.dateData = [];
      }
    },

    //列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Commission/GetCommissionFlowList",
        params: params,
        success(res) {
          console.log(res);
          for (var i = 0; i < res.items.length; i++) {
                        if (res.items[i].commissionSource  == 1 ) {
                            res.items[i].commissionSource = "上二级";
                        } else if (res.items[i].commissionSource == 2) {
                            res.items[i].commissionSource = "上一级";
                        } else {
                            res.items[i].commissionSource = "后台调整";
                        }
                    }
          self.searchListTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },

    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      this.getDatas(params);
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      debugger;
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.searchForm;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    }
  }
};
</script>

<style lang='scss' scoped>
.searchBox{
    background: #fff;
}
.el-form-item{
margin:20px;
}
</style>
